import React, { useEffect, useState } from 'react';
import * as OrdersActions from '../../redux/orders/actions';
import Spinner from 'react-spinkit';
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import CopyToClipboard from 'copy-to-clipboard';
import MaterialDataTable from '../../components/OrdersDataTable';
import {cancelOrder, fetchOrdersRequested, verifyOrder} from '../../store/orders/actions';


function OrdersPage() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isOrdersLoading, orders } = useSelector(state => state.orders);

  const [copy, setCopy] = useState(false);
  useEffect(() => {
    dispatch(fetchOrdersRequested());
  }, []);

  const handleVerify = (order) => {
      dispatch(verifyOrder({id:order.id}))
    // dispatch(OrdersActions.verifyOrder(
  };

  const handleCopyLink = (text) => {
    CopyToClipboard(text);
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 2000);
  };

  const handleCancel = (order) => {
      dispatch(cancelOrder({id:order.id}))
  };

  const onEdit = (rowData) => {
    history.push(`/dashboard/orders/${rowData.id}/edit`, { event: rowData });
  };

  return (
    <div style={{ width: '98%' }}>
      {
        isOrdersLoading &&
        <div>
          <Spinner name="circle" className="spinner" fadeIn="quarter" color="#3897dc"/>
          <div className="overlay">
          </div>
        </div>
      }
      <div>
        <h3>Заказы</h3>
        {
          copy &&
          <div className="alert alert-success" role="alert">
            Ссылка на заказ скопирована
          </div>
        }
      </div>
      <br/>
      <MaterialDataTable
        title={null}
        data={orders.map(o => ({ ...o }))}
        handleCopyLink={handleCopyLink}
        onEdit={onEdit}
        handleCancel={handleCancel}
        handleVerify={handleVerify}
      />
      <div className="table-responsive">
      </div>
    </div>
  );

}

export default OrdersPage;



// WEBPACK FOOTER //
// ./src/pages/OrdersPage/index.jsx